import customTheme from "../../../theme";

export const titleIcons = {
	access: {
		color: customTheme.paleta.gris90,
		src: "report_gmailerrorred_outlined"
	},
	error: {
	  color: customTheme.paleta.error30,
	  src: "do_not_disturb_alt_rounded",
	},
	warning: {
	  color: customTheme.paleta.warning30,
	  src: "warning_amber_rounded",
	},
	info: {
	  color: customTheme.paleta.info30,
	  src: "info_outlined",
	},
	done: {
	  color: customTheme.paleta.success30,
	  src: "check_circle_outline_rounded",
	},
	inProgress: {
	  color: customTheme.paleta.inProgress30,
	  src: "history_toggle_off_rounded",
	},
};